// extracted by mini-css-extract-plugin
export default {"card":"WeatherCard_card__3PvRK","temp":"WeatherCard_temp__OsiDt","desc":"WeatherCard_desc__-XTg1"};